// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"351":"commons","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"351":"b38f1a93123737b0e1f4","678":"94ab251867dd248d090e","883":"479a3fb822ba0028dec3"}[chunkId] + ".js";
};